

import { useState } from 'react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const images = [
    {
      src: "https://static.readdy.ai/image/d0b3748824a95918108ba1adb67e0e25/fd52602a17c64459a54e64520dab6dec.jpeg",
      alt: "Vista geral da propriedade"
    },
    {
      src: "https://static.readdy.ai/image/d0b3748824a95918108ba1adb67e0e25/7f760af46b8dee7f44302125bcce0daf.jpeg",
      alt: "Área externa com natureza"
    },
    {
      src: "https://static.readdy.ai/image/d0b3748824a95918108ba1adb67e0e25/3773338d01015c1db2722264da31e1f9.jpeg",
      alt: "Casa principal"
    },
    {
      src: "https://static.readdy.ai/image/d0b3748824a95918108ba1adb67e0e25/590cb0f9f1cfe3626063fac2ce962c40.jpeg",
      alt: "Ambiente natural preservado"
    },
    {
      src: "https://static.readdy.ai/image/d0b3748824a95918108ba1adb67e0e25/abdfb2098e4c9c34c663c9790c257ef6.jpeg",
      alt: "Vista da propriedade"
    },
    {
      src: "https://static.readdy.ai/image/d0b3748824a95918108ba1adb67e0e25/042053128beac89d8a64f6306f464264.jpeg",
      alt: "Área de lazer"
    }
  ];

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-light text-stone-800 mb-6">
            Galeria de <span className="text-olive-600">momentos</span>
          </h2>
          <p className="text-xl text-stone-600 max-w-3xl mx-auto leading-relaxed">
            Cada canto da nossa casa foi pensado para criar memórias especiais. 
            Conheça os espaços que farão parte da sua experiência de descanso.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {images.map((image, index) => (
            <div 
              key={index}
              className="relative group cursor-pointer overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300"
              onClick={() => setSelectedImage(image.src)}
            >
              <img 
                src={image.src}
                alt={image.alt}
                className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center">
                <i className="ri-zoom-in-line text-white text-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></i>
              </div>
            </div>
          ))}
        </div>

        {selectedImage && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-90 flex items-center justify-center z-50 p-4"
            onClick={() => setSelectedImage(null)}
          >
            <div className="relative max-w-4xl max-h-full">
              <img 
                src={selectedImage}
                alt="Imagem ampliada"
                className="max-w-full max-h-full object-contain rounded-lg"
              />
              <button 
                className="absolute top-4 right-4 text-white text-3xl hover:text-stone-300 transition-colors cursor-pointer"
                onClick={() => setSelectedImage(null)}
              >
                <i className="ri-close-line"></i>
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;


